import { useFormContext } from 'react-hook-form'

import MedicationContent from '../MedicationContent'
import CheckIcon from '@ui-components-3/icons/lib/regular/Check'

type RequestedMedicationsProps = {
  requestedMedications?: {
    medicationName: string
    medicationDirections: string
    medicationNotes?: string
    medicationUnit: string
    medicationSubstitutions: string
    medicationWrittenDate: string
    medicationQuantity: string
    medicationRefills: string
    medicationDaysSupply: number
  }[]
}

const RequestedMedications = ({ requestedMedications }: RequestedMedicationsProps) => {
  const { watch, setValue } = useFormContext()

  const selectedMedicationIndex = watch('selectedIndex')

  const handleSelect = (selectedIndex) => {
    setValue('selectedIndex', selectedIndex, {
      shouldValidate: true,
    })
  }
  const handleUnselect = () => setValue('selectedIndex', -1, { shouldValidate: true })

  return (
    <>
      {!!requestedMedications?.length && <p className="typography-caption text-neutral-500">Requested Medication(s)</p>}
      {requestedMedications?.map((r, i) => (
        <div key={i} className="mb-4">
          <div className="flex flex-col-reverse sm:flex-row justify-between gap-2">
            <MedicationContent
              medication={r.medicationName}
              directions={r.medicationDirections}
              notes={r.medicationNotes}
              unit={r.medicationUnit}
              substitutions={r.medicationSubstitutions}
              writtenDate={r.medicationWrittenDate}
              quantity={r.medicationQuantity}
              refills={r.medicationRefills}
              daysSupply={r.medicationDaysSupply}
            />

            <div className="shrink-0">
              {selectedMedicationIndex === i ? (
                <button type="button" className="btn-md btn-secondary" onClick={handleUnselect}>
                  <CheckIcon aria-hidden="true" />
                  Medication
                </button>
              ) : (
                <button type="button" className="btn-md btn-secondary-outlined" onClick={() => handleSelect(i)}>
                  Select Medication
                </button>
              )}
            </div>
          </div>

          {i !== requestedMedications?.length - 1 && <hr className="my-4" />}
        </div>
      ))}
    </>
  )
}

export default RequestedMedications
